import styled, { css } from 'styled-components';
import { Segment, Flex, Step as SharedStep } from 'nallian-shared-ui/lib/components';

export const FormSegment = styled(Segment)`
  max-width: 50rem;
  min-height: 25rem;
  display: flex;
  flex-flow: column;
  &.ui.segment {
    margin: 0 auto;
  }
  && .ui.grid > .column:not(.row) {
    padding-top: 0;
  }

  && .ui.grid {
    margin-top: -0.5rem;
  }
`;

export const IndicatorWrapper = styled.div`
  margin-bottom: 1rem;

  p {
    margin-bottom: 0.5rem;
  }

  h2 {
    margin-bottom: 1rem;
    display: flex;
  }
`;

export const WelcomeText = styled(Flex)`
  max-width: 400px;
  text-align: center;
`;

export const Hidden = styled.div`
  ${props =>
    props.hidden &&
    css`
      display: none;
    `}
`;

export const Step = styled(SharedStep)`
  width: ${props => props.width || '50%'};
  padding-left: 1rem !important;
  padding-right: 0 !important;

  ${props =>
    props.error &&
    css`
      color: ${props.theme.stateError} !important;
      && .content .title {
        color: ${props.theme.stateError} !important;
      }
      && .content .description {
        color: ${props.theme.stateError} !important;
      }
    `}
`;

export const StepNumber = styled(Flex)`
  font-size: 3rem;
  font-weight: bold;
  margin: -0.3rem 1.5rem 0 0;
  height: 100%;
  align-items: center;
`;

export const DisplayNone = styled.div`
  ${props =>
    props.active &&
    css`
      display: none;
    `}

  ${props =>
    props.withMargin &&
    css`
      margin-top: 1.5rem;
    `}
`;

export const StepGroup = styled(Step.Group)`
  margin-top: -1.5rem;

  &&.ui.fluid.steps {
    margin-top: 0;
  }
`;

export const CursorPointer = styled.div`
  cursor: pointer;
`;
